<div class="modal-header">
  <h4 class="modal-title h5" translate>Trigger configuration</h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form [formGroup]="triggerConfigurationForm">
  <div class="modal-body">
    <div class="row">
      <!-- NAME -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="name" translate>Name</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <input [ngClass]="{ 'is-invalid': f.name.touched && f.name.errors }"
            class="form-control" formControlName="name"
            id="name" name="name" type="text">
            @if (f.name.touched && f.name.errors) {
              <div class="invalid-feedback">
                @if (f.name.errors.required) {
                  <span translate>Trigger configuration name required</span>
                }
              </div>
            }
          </div>
        </div>

        <!-- ACTION TYPE -->
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label for="triggerType" translate>Configuration type</label>
            <scitis-required-field-indicator></scitis-required-field-indicator>
            <ng-select [ngClass]="{ 'is-invalid': f.triggerType.touched && f.triggerType.errors }"
              [closeOnSelect]="true"
              [items]="triggerTypes" id="triggerType"
              (change)="onTriggerTypeChange($event); removeTriggerExpressions();"
              formControlName="triggerType">
            </ng-select>
            @if (f.triggerType.touched && f.triggerType.errors) {
              <div class="invalid-feedback">
                @if (f.triggerType.errors.required) {
                  <span translate>Trigger configuration type required</span>
                }
              </div>
            }
          </div>
        </div>
      </div>

      <!--    TRIGGER QUERIES-->
      <table class="table vertical-align-middle mb-0">
        <thead>
          <tr>
            <th translate>Trigger action</th>
            <th translate>Type</th>
            <th translate>Resolve e-mail</th>
            <th translate>Active</th>
            <th class="text-right" translate>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (triggerQuery of triggerConfiguration.triggerQueries; track triggerQuery) {
            <tr>
              <td>
                <span [ngClass]="getStatusCssClass(triggerQuery.initQueryExecuted)" class="status mr-1"></span>
                <b [innerText]="triggerQuery.name"></b>
              </td>
              <td [innerText]="triggerQuery.triggerActionType"></td>
              <td>
                <input (change)="onResolveEmailCheckBoxChange($event ,triggerQuery)"
                  [disabled]="userRole.isViewerRole"
                  [checked]="triggerQuery.isResolveEvent" type="checkbox">
                </td>
                <td>
                  <span [ngClass]="getStatusCssClass(!triggerQuery.bannedInactive)"
                  class="status"></span>
                </td>
                <td class="text-right">
                  <button (click)="onRemoveTriggerQuery(triggerQuery)"
                    class="btn btn-sm btn-outline-danger"
                    [title]="'Delete trigger action' | translate"
                    type="button" [disabled]="!isDistributorOrHigher"><span
                  class="fa-solid fa-trash"></span></button>
                </td>
              </tr>
            }
          </tbody>
        </table>

        <!--Add trigger action-->
        <div class="form-group py-2">
          @if (isLoadingTriggerQueries) {
            <span class="fa-solid fa-spinner fa-spin"></span>
          }
          @if (triggerQueriesList.length > 0) {
            <ng-select
              (change)="onTriggerActionSelected($event)"
              [clearable]="false"
              [items]="triggerQueriesList"
              bindLabel="name"
              bindValue="id"
              formControlName="triggerAction"
              id="triggerAction"
              placeholder="Select trigger action">
            </ng-select>
          }
        </div>

        <!--    VALUE BASED SUB GROUP-->
        @if (showValueBasedComponent()) {
          <scitis-admin-value-based
            (formIsValid)="onValueBasedFormIsValid($event)"
            (updatedTriggerConfiguration)="onUpdatedValueBased($event)"
            (loadSignalsForCloudPlug)="onLoadSignalsForCloudPlug($event)"
            [isAdminOrHigher]="isAdminOrHigher"
            [isSuperAdmin]="isSuperAdmin"
            [selectedTriggerType]="f.triggerType.value"
            [submitted]="submitted"
            [isMachineryGroupsConfigs]="true"
            [machineGroupId]="machineGroupId"
            [signals]="signals"
            [cloudPlugs]="cloudPlugs"
            [whiteListMachinesIds]="whiteListMachinesIds"
            [isLoadingCloudPlugs]="isLoadingCloudPlugs"
            [triggerConfiguration]="triggerConfiguration">
          </scitis-admin-value-based>
        }


        <!-- SEVERITY LABEL -->
        @if (showEventSeverityBased()) {
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="severity" translate>Severity</label>
                <scitis-required-field-indicator></scitis-required-field-indicator>
                <ng-select
                  [ngClass]="{ 'is-invalid': f.severity.touched && f.severity.errors }"
                  [items]="severityLabels"
                  [multiple]="true"
                  [clearable]="true"
                  [closeOnSelect]="false"
                  id="severity"
                  formControlName="severity">
                </ng-select>
                @if (f.severity.touched && f.severity.errors) {
                  <div class="invalid-feedback">
                    @if (f.severity.errors.required) {
                      <span translate>Severity is required</span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
        <hr>
        </div>

        <scitis-modal-footer
          (cancelButtonPressed)="onClose()"
          (okButtonPressed)="onSave()"
          [cancelButtonText]="'Cancel'|translate"
          [disableOkButton]="isDisabledSaveBtn"
          [okButtonText]="'Save'|translate"
          [showRequiredFieldsIndicator]="true">
        </scitis-modal-footer>

      </form>
